import { PAYMENTS_API } from '../globals';
import { client } from './setup';

export default {
    createCheckoutSession: (booking) => client.get(`${PAYMENTS_API}/${booking}/checkout-session`),
}